import { snakelize, camelize } from "../../../helpers/object"

export default ($axios: any) => ({
  async index(lectureId: number, lessonId: number, params?: any) {
    return camelize(await $axios.get(`/lecture/${lectureId}/${lessonId}/chapters`, snakelize({ params })))
  },
})
